import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const DeliveryPartners = () => {
  const partners = [
  {
    name: 'Swiggy',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_192aac26d-1764582860897.png",
    logoAlt: 'Swiggy food delivery service logo with orange and white branding on mobile phone screen',
    available: true
  },
  {
    name: 'Zomato',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_13efe21f7-1764582861987.png",
    logoAlt: 'Zomato food delivery app logo with red branding displayed on smartphone interface',
    available: true
  },
  {
    name: 'Dunzo',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_165018f7f-1764582860099.png",
    logoAlt: 'Dunzo quick delivery service logo with yellow branding on mobile application screen',
    available: true
  }];


  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 border border-[var(--color-border)]">
      <h3 className="text-lg font-semibold text-[var(--color-foreground)] mb-4 flex items-center gap-2">
        <Icon name="Truck" size={24} color="var(--color-primary)" />
        Delivery Partners
      </h3>
      <div className="grid grid-cols-3 gap-4">
        {partners?.map((partner, index) =>
        <div
          key={index}
          className="relative aspect-video rounded-lg overflow-hidden border border-[var(--color-border)] bg-white hover:shadow-md transition-shadow duration-300">

            <Image
            src={partner?.logo}
            alt={partner?.logoAlt}
            className="w-full h-full object-contain p-2" />

            {partner?.available &&
          <div className="absolute top-1 right-1">
                <div className="w-2 h-2 rounded-full bg-[var(--color-trust-green)]" />
              </div>
          }
          </div>
        )}
      </div>
      <p className="text-xs text-[var(--color-muted-foreground)] mt-4 text-center">
        Order from your favorite delivery app
      </p>
    </div>);

};

export default DeliveryPartners;